<script>
  import {
    generateId,
  } from '../plugins/utils.js'
  import {
    MinusSquareIcon,
    PlusSquareIcon,
  } from 'vue-feather-icons'

  

  export default {
    name: 'FabricSpinButton',
    components: {
      MinusSquareIcon,
      PlusSquareIcon,
    },
    model: {
      prop: 'modelValue',
      event: 'change'
    },
    props: {
      modelValue: {
        type: Number,
        required: true,
      },
      id: {
        type: [String],
        default: (() => generateId()),
      },
      min: {
        type: [String, Number],
        default: null,
      },
      max: {
        type: [String, Number],
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      inheritedBackground: {
        type: Boolean,
        default: false,
      },
    },
    computed:{
      resolvedMin() {
        return Number(this.min)
      },
      resolvedMax() {
        return Number(this.max)
      },
    },
    methods: {
      decrement(){
        if (this.disabled){
          return
        }
        if (this.min !== null && this.resolvedMin >= 0 && this.resolvedMin < this.modelValue){
          this.$emit('change', Number(this.modelValue - 1))
        }
      },
      increment(){
        if (this.disabled){
          return
        }
        if (this.max !== null && this.resolvedMax > 0 && this.resolvedMax > this.modelValue){
          this.$emit('change', Number(this.modelValue + 1))
        }
      },
    }
  }
</script>

<template>
  <div 
    :id="id + '___FB_spinButton_'"
    :class="[
      'tw-flex tw-justify-between',
      {
        'tw-mix-blend-luminosity': disabled,
      },
    ]">
    <span 
      :class="[
        'tw-inline-flex justify-content-center',
        {
          'tw-cursor-pointer': !disabled,
        },
      ]"
      @click="decrement"><MinusSquareIcon class="tw-fill-negative tw-stroke-1.5"/></span>
    <input 
      v-model="modelValue"
      disabled
      :class="[
        'tw-text-center tw-max-w-[4rem]',
        {
          'tw-bg-white': !inheritedBackground,
        },
      ]"
      type="text"
    />
    <span 
      :class="[
        'tw-inline-flex justify-content-center',
        {
          'tw-cursor-pointer': !disabled,
        },
      ]"
      @click="increment"><PlusSquareIcon class="tw-fill-active tw-stroke-1.5"/></span>
  </div>
</template>